<template>
  <transition
    appear
    name="transition-scale-fade"
  >
    <div
      v-show="isShowing"
      ref="modal"
      class="modal"
      :style="componentStyle"
    >
      <article :class="`${modalClass} card roomy with-close modal-content transition-scale-fade-content`">
        <slot name="title">
          <div
            v-if="title"
            :class="['text-left', hasSections ? 'section padding-bottom-lg' : 'padding-bottom-2xl']"
          >
            <div
              class="display-flex flex-items-center"
              style="gap: var(--spacing-md)"
            >
              <h2 :class="titleClass">
                {{ title }}
              </h2>

              <slot name="title-tag" />
            </div>
          </div>
        </slot>

        <slot name="content">
          <div :class="['text-left', { section: hasSections }]">
            <slot />
          </div>
        </slot>

        <slot name="footer">
          <div
            v-if="hasActions"
            :class="['text-left', hasSections ? 'section' : 'padding-top-2xl']"
          >
            <slot name="actions" />
          </div>
        </slot>

        <button
          type="button"
          :aria-label="closeLabel"
          data-balloon-pos="left"
          class="close margin-top-0"
          @click.prevent="$emit('close-modal')"
        >
          <font-awesome-icon
            :icon="$v7.duotone.faCircleXmark"
            style="--fa-width: auto"
            size="lg"
          />
        </button>
      </article>
    </div>
  </transition>
</template>

<script>
  import Modal from 'app/mixins-wa/modal'
  import sluggify from 'app/utils/sluggify'

  export const ModalFrameMixin = {
    props: {
      isShowing: {
        type: Boolean,
        default: false
      }
    }
  }

  export default {
    name: 'ModalFrame',
    mixins: [Modal],

    props: {
      closeLabel: {
        type: String,
        default: 'Close'
      },
      componentClass: {
        type: String
      },
      customStyle: {
        type: Object,
        default: () => {}
      },
      hasActions: {
        type: Boolean,
        default: false
      },
      hasLongTitle: {
        type: Boolean,
        default: false
      },
      hasSections: {
        type: Boolean,
        default: true
      },
      isShowing: {
        type: Boolean,
        default: false
      },
      title: {
        type: String
      }
    },

    computed: {
      componentStyle() {
        return {
          ...this.customStyle,
          ...{ 'z-index': 'var(--depth-foreground)' }
        }
      },

      modalClass() {
        if (this.componentClass) {
          return `${this.componentClass}-modal-content`
        } else if (this.title) {
          return `${sluggify(this.title)}-modal-content`
        } else {
          return ''
        }
      },

      titleClass() {
        return ['text-truncate', { h3: this.hasLongTitle }]
      }
    }
  }
</script>
